/* cwc-page-flip */

//:host {
cwc-page-flip {
  display: block;
  background-color: inherit;

  .flip-book {
    display: none;
    position: relative;
    height: auto;
    background-size: cover;
  }

  /* WILL DISABLE ONE LINT FACT BECAUSE OF THIRD PARTY HTML StPageFlip */
  /* stylelint-disable selector-max-compound-selectors, max-nesting-depth */

  .flip-book-page {
    overflow: hidden;
    border: solid 1px hsl(35, 20%, 70%);
    background-color: hsl(35, 55%, 98%);
    color: hsl(35, 35%, 35%);

    .flip-book-page-content {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: space-between;
      width: 100%;
      height: 100%;

      .flip-book-page-header {
        height: 30px;
        font-size: 100%;
        text-align: center;
        text-transform: uppercase;
      }

      .flip-book-page-image {
        height: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
      }

      .flip-book-page-text {
        box-sizing: border-box;
        flex-grow: 1;
        height: 100%;
        margin-top: 10px;
        padding-top: 10px;
        border-top: solid 1px hsl(35, 55%, 90%);
        font-size: 80%;
        text-align: justify;
      }

      .flip-book-page-footer {
        height: 30px;
        border-top: solid 1px hsl(35, 55%, 90%);
        color: hsl(35, 20%, 50%);
        font-size: 80%;
      }
    }

    &.--left {
      border-right: 0;
      box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.4) !important;
    }

    &.--right {
      border-left: 0;
      box-shadow: 4px 0 3px 1px rgba(0, 0, 0, 0.4) !important;

      .flip-book-page-footer {
        text-align: right;
      }
    }

    &.hard {
      // for hard page
      border: solid 1px hsl(35, 20%, 50%);
      background-color: hsl(35, 50%, 90%);
    }

    &.flip-book-page-cover {
      border: solid 1px hsl(35, 20%, 50%);
      background-color: hsl(35, 45%, 80%);
      color: hsl(35, 35%, 35%);

      h2 {
        padding-top: 50%;
        font-size: 210%;
        text-align: center;
      }

      &.flip-book-page-cover-top {
        box-shadow:
          inset 0 0 30px 0 rgba(36, 10, 3, 0.5),
          -2px 0 5px 2px rgba(0, 0, 0, 0.4);
      }

      &.flip-book-page-cover-bottom {
        box-shadow:
          inset 0 0 30px 0 rgba(36, 10, 3, 0.5),
          10px 0 8px 0 rgba(0, 0, 0, 0.4);
      }
    }
  }

  /* stylelint-enable selector-max-compound-selectors, max-nesting-depth */

  .flip-book-controls {
    position: relative;
    margin: 2rem 0 1rem;
    text-align: center;

    .sg-cw-button {
      margin: 0 15px;
    }
  }
}

cwc-page-flip[fullscreen] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 1.5rem;
  background-color: #fafafa;

  .flip-book {
    position: relative;
    margin: 3rem 1rem 0;
    background: inherit;
  }

  .flip-book-controls {
    position: relative;
    flex: 1 1 auto;
    margin: 2rem 0 1rem;
    background: inherit;
  }
}

//} //host
